import Cookies from 'js-cookie';

// export function regionPopup() {
//   $('body').on('click', '#change-region-no, .popup-closer', function () {
//     $('#region-popup').hide();
//     $('body').removeClass('locked');
//     Cookies.set('n4_region', window.localized_object.current_region);

//     return false;
//   });

//   $('body').on('click', '#region-popup', function () {
//     $('#region-popup').hide();
//     $('body').removeClass('locked');
//     return false;
//   });

//   $('body').on('click', '.popup-contents', function (e) {
//     e.stopPropogation();
//   });

//   $(document).on('keydown', function (event) {
//     if (event.key == 'Escape') {
//       $('#region-popup').hide();
//       $('body').removeClass('locked');
//     }
//   });
// }
